// Copyright The Perses Authors
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { PersesColor } from './types';

export const grey: PersesColor = {
  50: '#F0F1F6',
  100: '#E1E3ED',
  150: '#D2D5E4',
  200: '#C3C7DB',
  300: '#A4ACC8',
  400: '#8690B6',
  500: '#717CA4',
  600: '#535D83',
  700: '#3E4662',
  800: '#2A2E42',
  850: '#1F2331',
  900: '#151721',
  950: '#0A0C10',
};
